import apiClient from './apiClient';
import { NgHotel } from '../types/ngHotel';

const API_URL = '/users_edit';

// NGホテルを追加するためのデータ型
export type AddNgHotelData = {
  hotel_id?: number | null;
  hotel_name?: string;
  notes?: string;
};

// キャストのNGホテル一覧を取得
export const getNgHotels = async (userId: number): Promise<NgHotel[]> => {
  const response = await apiClient.get<NgHotel[]>(`${API_URL}/${userId}/ng_hotels`);
  return response.data;
};

// NGホテルを追加
export const addNgHotel = async (userId: number, data: AddNgHotelData): Promise<NgHotel> => {
  const response = await apiClient.post<NgHotel>(`${API_URL}/${userId}/ng_hotels`, data);
  return response.data;
};

// NGホテルを削除
export const deleteNgHotel = async (userId: number, ngHotelId: number): Promise<void> => {
  await apiClient.delete(`${API_URL}/${userId}/ng_hotels/${ngHotelId}`);
};

const ngHotelService = {
  getNgHotels,
  addNgHotel,
  deleteNgHotel,
};

export default ngHotelService;
